module.exports = __webpack_public_path__ + "media/images/slideshow-70bc42375b2e091476683b031465abef.svg";